import {
    Component,
    Inject,
    Input,
    OnInit,
    OnDestroy
} from '@angular/core';

import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, switchMap, scan } from 'rxjs/operators';

import { TOAST_DATA } from '../toastr.service';
import { ToastRef } from '../toast-ref';

@Component({
    selector: 'app-toast-taking-from-steam',
    templateUrl: './toast-taking-from-steam.component.pug',
    styleUrls: ['./toast-taking-from-steam.component.less'],
})
export class ToastTakingFromSteamComponent implements OnDestroy, OnInit {
    _takenSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    taken$: Observable<number> = this._takenSbj.asObservable();
    @Input() set taken(taken: number) {
        this._takenSbj.next(taken || 0);
    }
    get taken(): number {
        return this._takenSbj.getValue();
    }

    _takingSbj: BehaviorSubject<number> = new BehaviorSubject(null);
    taking$: Observable<number> = this._takingSbj.asObservable();
    @Input() set taking(taking: number) {
        this._takingSbj.next(taking || 0);
    }
    get taking(): number {
        return this._takingSbj.getValue();
    }

    @Input() duration = 1000;
    progress$ = this.taking$
        .pipe(scan((acc) => [...acc, new Date() .getTime()], []))
        .pipe(switchMap((values) => timer(0, 1).pipe(map(() => values))))
        .pipe(map((values) => {
            const now = new Date() .getTime();
            const length = values.length;

            // console.log(this.duration);
            return values.map((start) => progressLog10((now - start), this.duration) / length);
        }))
        .pipe(map((values) => values.reduce((x, y) => x + y, 0)))
        .pipe(map((value) => `${ value > 100 ? 100 : value }%`));

    constructor(
        private _toastRef: ToastRef<ToastTakingFromSteamComponent>,

        @Inject(TOAST_DATA) public data: any
    ) {
        this.taken = data.taken;
        this.taking = data.taking;
        this.duration = data.duration;
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        
    }

    onStop() {
        this._toastRef.close(false);
    }
}

// Max progress value is 100
const PROGRESS_MULTIPLE = 50;
function progressLog10(cur, max) {
    if (cur > max) {
        return 100;
    }

    const x = 100 * cur / max;

    return Math.max(Math.round(PROGRESS_MULTIPLE * Math.log10(x)), 0);
}
